import { render } from "./ConfiguracoesLayoutBase.vue?vue&type=template&id=4910f03c&scoped=true"
const script = {}

import "./ConfiguracoesLayoutBase.vue?vue&type=style&index=0&id=4910f03c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4910f03c"]])

export default __exports__